import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getChangeTripReasonCategories, clearChangeTripReasonCategories } from '../../../../actions';
import { DEFAULT_SELECT_PLACEHOLDER } from '../../../../config/constants';
import Select from './Select';
import { optionsPropTypes } from './SelectPropTypes';

const ChangeTripReasonCategorySelect = ({
  dispatchClearChangeTripReasonCategories,
  dispatchGetChangeTripReasonCategories,
  loading,
  options,
  ...rest
}) => {

  useLayoutEffect(() => {
    dispatchGetChangeTripReasonCategories();
    return () => {
      dispatchClearChangeTripReasonCategories();
    };
  }, [dispatchGetChangeTripReasonCategories, dispatchClearChangeTripReasonCategories]);

  return (
    <Select
      options={options}
      placeholder={DEFAULT_SELECT_PLACEHOLDER}
      isLoading={loading}
      {...rest}
    />
  )
}

ChangeTripReasonCategorySelect.propTypes = {
  dispatchClearChangeTripReasonCategories: PropTypes.func.isRequired,
  dispatchGetChangeTripReasonCategories: PropTypes.func.isRequired,
  options: optionsPropTypes.isRequired,
  loading: PropTypes.bool,
}

ChangeTripReasonCategorySelect.defaultProps = {
  loading: false,
}

const mapStateToProps = ({ ItineraryUnit }) => ({
  loading: ItineraryUnit.Itinerary.getIn(['current', 'changeTripReasonCategoriesLoading']),
  options: ItineraryUnit.Itinerary.getIn(['current', 'changeTripReasonCategories']).map(category => ({
    value: category.id,
    label: category.name
  })),
})

const mapDispatchToProps = {
  dispatchClearChangeTripReasonCategories: clearChangeTripReasonCategories,
  dispatchGetChangeTripReasonCategories: getChangeTripReasonCategories,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeTripReasonCategorySelect);